/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetAccountHistories200Response } from '../models';
// @ts-ignore
import { HistoryType } from '../models';
/**
 * AccountHistoryApi - axios parameter creator
 * @export
 */
export const AccountHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * アカウント履歴一覧取得API
         * @summary アカウント履歴一覧取得API
         * @param {string} key 会社名（URL エンコードされた文字列）
         * @param {number} [callTargetId] リードID
         * @param {HistoryType} [historyType] 履歴種別
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountHistories: async (key: string, callTargetId?: number, historyType?: HistoryType, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('getAccountHistories', 'key', key)
            const localVarPath = `/api/user/accounts/{key}/histories`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (callTargetId !== undefined) {
                localVarQueryParameter['callTargetId'] = callTargetId;
            }

            if (historyType !== undefined) {
                localVarQueryParameter['historyType'] = historyType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountHistoryApi - functional programming interface
 * @export
 */
export const AccountHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * アカウント履歴一覧取得API
         * @summary アカウント履歴一覧取得API
         * @param {string} key 会社名（URL エンコードされた文字列）
         * @param {number} [callTargetId] リードID
         * @param {HistoryType} [historyType] 履歴種別
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountHistories(key: string, callTargetId?: number, historyType?: HistoryType, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAccountHistories200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountHistories(key, callTargetId, historyType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AccountHistoryApi - factory interface
 * @export
 */
export const AccountHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountHistoryApiFp(configuration)
    return {
        /**
         * アカウント履歴一覧取得API
         * @summary アカウント履歴一覧取得API
         * @param {string} key 会社名（URL エンコードされた文字列）
         * @param {number} [callTargetId] リードID
         * @param {HistoryType} [historyType] 履歴種別
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountHistories(key: string, callTargetId?: number, historyType?: HistoryType, options?: any): AxiosPromise<GetAccountHistories200Response> {
            return localVarFp.getAccountHistories(key, callTargetId, historyType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountHistoryApi - interface
 * @export
 * @interface AccountHistoryApi
 */
export interface AccountHistoryApiInterface {
    /**
     * アカウント履歴一覧取得API
     * @summary アカウント履歴一覧取得API
     * @param {string} key 会社名（URL エンコードされた文字列）
     * @param {number} [callTargetId] リードID
     * @param {HistoryType} [historyType] 履歴種別
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountHistoryApiInterface
     */
    getAccountHistories(key: string, callTargetId?: number, historyType?: HistoryType, options?: AxiosRequestConfig): AxiosPromise<GetAccountHistories200Response>;

}

/**
 * Request parameters for getAccountHistories operation in AccountHistoryApi.
 * @export
 * @interface AccountHistoryApiGetAccountHistoriesRequest
 */
export interface AccountHistoryApiGetAccountHistoriesRequest {
    /**
     * 会社名（URL エンコードされた文字列）
     * @type {string}
     * @memberof AccountHistoryApiGetAccountHistories
     */
    readonly key: string

    /**
     * リードID
     * @type {number}
     * @memberof AccountHistoryApiGetAccountHistories
     */
    readonly callTargetId?: number

    /**
     * 履歴種別
     * @type {HistoryType}
     * @memberof AccountHistoryApiGetAccountHistories
     */
    readonly historyType?: HistoryType
}

/**
 * AccountHistoryApi - object-oriented interface
 * @export
 * @class AccountHistoryApi
 * @extends {BaseAPI}
 */
export class AccountHistoryApi extends BaseAPI implements AccountHistoryApiInterface {
    /**
     * アカウント履歴一覧取得API
     * @summary アカウント履歴一覧取得API
     * @param {AccountHistoryApiGetAccountHistoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountHistoryApi
     */
    public getAccountHistories(requestParameters: AccountHistoryApiGetAccountHistoriesRequest, options?: AxiosRequestConfig) {
        return AccountHistoryApiFp(this.configuration).getAccountHistories(requestParameters.key, requestParameters.callTargetId, requestParameters.historyType, options).then((request) => request(this.axios, this.basePath));
    }
}
